import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import { EXPECTED_COOKIES, OBJECT_EMPTY, GET_TOKEN, ARRAY_EMPTY } from "./helpers";
import { API_URL, GET_ME, POST_TRESHOLD_ORDERS } from "./constants";

import { ContextNotifications } from './Context/ContextNotifications';
import { ContextOrders } from './Context/ContextOrders';

import Header from "./components/header/Header";
import { Dashboard } from "./components/dashboard/Dashboard";
import { RegisterLanding } from "./components/registerLanding/RegisterLanding";
import { RegisterUser } from "./components/registration/RegisterUser";
import { SelectProvider } from "./components/dashboard/provider/SelectProvider";
import { ProviderDistributor } from "./components/dashboard/provider/ProviderDistributor";
import { Modal } from "./components/Global/Modal/Modal";

import "normalize.css";
import "./App.css";
import "./global.css";
import { ReminderPassword } from "./components/reminderPassword/ReminderPassword";

function App() {
  const [userData, setUserData] = useState({});
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const [userNewPassword, setUserNewPassword] = useState(false);
  const [ordersCount, setOrdersCount] = useState(0);

  const levelTypes = {
    type1: 1,
    type2: 2,
    type3: 3,
    type4: 4,
  }

  let FAKE_NOTIF_CONTENT = [
    {
      name: 'Test Text hello my name is Jeopardize lorem why should i like it mmm?',
      type: 'error',
      date: '2021-07-13 69:21:13',
      checked: false,
      seen: true,
      id: 'ID1',
    },
    {
      name: 'Test Text hello my name is Jeopardize lorem why should i like it mmm?',
      type: 'success',
      date: '2021-07-13 69:21:13',
      checked: true,
      seen: false,
      id: 'ID2'
    },
    {
      name: 'Test Text hello my name is Jeopardize lorem why should i like it mmm?',
      type: 'success',
      date: '2021-07-13 69:21:13',
      checked: true,
      seen: false,
      id: 'ID3'
    },
    {
      name: 'Test Text hello my name is Jeopardize lorem why should i like it mmm?',
      type: 'success',
      date: '2021-07-13 69:21:13',
      checked: true,
      seen: false,
      id: 'ID4'
    },
    {
      name: 'Test Text hello my name is Jeopardize lorem why should i like it mmm?',
      type: 'success',
      date: '2021-07-13 69:21:13',
      checked: true,
      seen: false,
      id: 'ID5'
    },
    {
      name: 'Test Text hello my name is Jeopardize lorem why should i like it mmm?',
      type: 'success',
      date: '2021-07-13 69:21:13',
      checked: true,
      seen: false,
      id: 'ID6'
    },
  ]

  const initiateLogOut = () => {
    Cookies.remove(EXPECTED_COOKIES.userLoggedIn.name);
    Cookies.remove(EXPECTED_COOKIES.userJwt.name);
    Cookies.remove(EXPECTED_COOKIES.userName.name);
    Cookies.remove(EXPECTED_COOKIES.userLevel.name);
    setUserLoggedIn(false);
  };

  // Used for real, requires userName too
  const initiateRealLogIn = (jwt, expires_in) => new Promise((resolve, reject) => {
      fetch(API_URL + GET_ME, {
        headers: new Headers({
          Authorization: "Bearer " + jwt,
        }),
      })
        .then(res => res.json())
        .then((res) => {
          setUserData(res)

          res.type === null && initiateLogOut()
          
          // TODO fix this
          Cookies.set(EXPECTED_COOKIES.userLevel.name, res.type ? levelTypes[res.type] : 2, {
            expires: 65500
          });
  
          Cookies.set(EXPECTED_COOKIES.userLoggedIn.name, true, {
            expires: expires_in
          });
      
          Cookies.set(EXPECTED_COOKIES.userJwt.name, jwt, {
            expires: expires_in
          });
      
          Cookies.set(EXPECTED_COOKIES.userName.name, res.email, {
            expires: expires_in
          });
        })
        .then(() => resolve(!userLoggedIn && setUserLoggedIn(true)))
        .catch((err) => {
          reject(err.response)
          initiateLogOut();
        })
  });

  const checkCookieForInfo = () => {
    if (Cookies.get(EXPECTED_COOKIES.userJwt.name)) {
      !userLoggedIn && setUserLoggedIn(true);
    }
  };

  const getOrdersForMenuNotif = () => {
    fetch(API_URL + POST_TRESHOLD_ORDERS, {
      method: "get",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        setOrdersCount(response.length)
      })
      .catch(err => console.error(err))
  }

  useEffect(() => {
    // const constantMock = window.fetch;
    // window.fetch = () => {

    //    return constantMock.apply(this, arguments)
    // }
  }, [])

  // On page refresh || Initial page load
  useEffect(() => {
      fetch(API_URL + GET_ME, {
        headers: new Headers({
          Authorization: "Bearer " + GET_TOKEN(),
        }),
      })
        .then(res => res.json())
        .then(res => {
          (res && res.change_password) && setUserNewPassword(res.change_password)

          if (res === []) {
            initiateLogOut()
          } else {
            setUserData(res)
          }

        })
        // Logout on Error
        .catch((err) => {
          initiateLogOut()
        }) 
  }, [])

  useEffect(() => {
    if (!OBJECT_EMPTY(userData) && userData.change_password !== 1) {
      setUserNewPassword(userData.change_password)
    }
  }, [userData])

  useEffect(() => {
    if (userLoggedIn) getOrdersForMenuNotif()
  }, [userLoggedIn])


  return (
    <>
      {checkCookieForInfo()}

      <ContextNotifications.Provider value={FAKE_NOTIF_CONTENT}>
        <ContextOrders.Provider value={{ordersCount, getOrdersForMenuNotif}}>
          <Router>
            <Header
              userLoggedIn={userLoggedIn}
              initiateLogOut={initiateLogOut}
              userData={userData}
            />

            <div className="max-width-wrapper">
              <Switch>
                <Route
                  name="Dashboard"
                  path="/"
                  exact
                  render={(props) => {
                  
                    return (
                      (userLoggedIn && (
                        <Redirect
                          to="/dashboard/dashboard"
                          {...props}
                          userNewPassword={userNewPassword}
                          setUserNewPassword={setUserNewPassword}
                          key={props.match.params.type || "empty"}
                        />
                      )) 
                      
                      || (
                        <RegisterLanding
                          {...props}
                          initiateLogIn={initiateRealLogIn}
                          key={props.match.params.type || "empty"}
                        />
                      )
                    );
                  }}
                />

                <Route
                  name="Dashboard"
                  path="/dashboard"
                  exact
                  render={(props) => {
                    return (
                      <Redirect
                        to="/dashboard/dashboard"
                        userNewPassword={userNewPassword}
                        setUserNewPassword={setUserNewPassword}
                        {...props}
                        key={props.match.params.type || "empty"}
                      />
                    );
                  }}
                />

                <Route
                  name="userDashboard"
                  path="/dashboard/dashboard"
                  exact
                  render={(props) => {
                    return (
                      (userLoggedIn && (
                        <Dashboard
                          {...props}
                          userNewPassword={userNewPassword}
                          setUserNewPassword={setUserNewPassword}
                          key={props.match.params.type || "empty"}
                        />
                      )) || (
                        <Redirect
                          to="/login"
                          {...props}
                          key={props.match.params.type || "empty"}
                        />
                      )
                    );
                  }}
                />

                <Route
                  name="RegisterUser"
                  path="/register/:userType"
                  render={(props) => {
                    if (GET_TOKEN() === undefined) {
                      return <RegisterUser
                          {...props}
                          initiateRealLogIn={initiateRealLogIn}
                          key={props.match.params.type || "empty"}
                        />
                      
                    } else {
                      return <Redirect to="/" />
                    }
                  }}
                />

                <Route
                  name="LoginUser"
                  path="/login/user"
                  render={(props) => {
                    return (
                      (userLoggedIn && (
                        <Redirect
                          to="/dashboard/dashboard"
                          {...props}
                          userNewPassword={userNewPassword}
                          setUserNewPassword={setUserNewPassword}
                          key={props.match.params.type || "empty"}
                        />
                      )) || (
                        <RegisterLanding
                          {...props}
                          initiateLogIn={initiateRealLogIn}
                          key={props.match.params.type || "empty"}
                        />
                      )
                    );
                  }}
                />

                <Route
                  name="Reminder password"
                  path="/reminder"
                  exact
                  render={(props) => {
                    return (
                     (
                        <ReminderPassword
                          {...props}
                          initiateLogIn={initiateRealLogIn}
                          key={props.match.params.type || "empty"}
                        />
                      )
                    );
                  }}
                />

                <Route
                  name="apiProvider"
                  path="/user/provider"
                  exact
                  render={(props) => {
                    return (
                      <SelectProvider
                        {...props}
                        key={props.match.params.type || "empty"}
                      />
                    );
                  }}
                />

                <Route
                  name="apiProvider"
                  path="/user/provider/:providerType"
                  render={(props) => {
                    return (
                      <ProviderDistributor {...props}/>
                    );
                  }}
                />

                <Route
                  path="*"
                  exact={true}
                  render={(props) => {
                    return (
                      (userLoggedIn && (
                        <Dashboard
                          {...props}
                          userNewPassword={userNewPassword}
                          setUserNewPassword={setUserNewPassword}
                          key={props.match.params.type || "empty"}
                        />
                      )) || <Redirect to="/" />
                    );
                  }}
                />
              </Switch>
            </div>

          </Router>
        </ContextOrders.Provider>
      </ContextNotifications.Provider>
    </>
  );
}

export default App;
